<div
  class="responsive-flex-wrapper checkbox-container-wrapper"
  [class.checkbox-disabled]="disabled"
  [attr.qa-checked]="isChecked"
  (click)="onChecked($event)">
  <label class="check-container">
    <input
      type="checkbox"
      [checked]="isChecked"
      [disabled]="disabled"
      [attr.aria-label]="ariaLabel"/>
    <span class="custom-radio-label checkmark" aria-hidden="true"></span>
  </label>
</div>
